"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffReqHandles = diffReqHandles;
function allIds(req) {
    return [...req.included, ...req.excluded, ...req.constraints].map(i => i.id);
}
/**
 * Pure deterministic referential-integrity check between a req's prior body
 * (`prev`) and a proposed new body (`next`). No IO, no AI.
 *
 * The single invariant: **every handle present in `prev` must still be present
 * in `next`.** A vanished handle is a violation — either an outright delete or a
 * renumber (the old id disappears while a fresh one appears). New ids in `next`
 * are allowed appends; a `dropped` item still appears in `next` (only its status
 * changed) so retiring a requirement is never a deletion.
 */
function diffReqHandles(prev, next) {
    const prevIds = allIds(prev);
    const nextIds = new Set(allIds(next));
    const prevSet = new Set(prevIds);
    const deleted = prevIds.filter(id => !nextIds.has(id));
    const added = [...nextIds].filter(id => !prevSet.has(id));
    return { deleted, added, ok: deleted.length === 0 };
}
